import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { FiltersWrapper } from 'components/pages/PhasePerformancePage/components/FiltersWrapper/FiltersWrapper';
import { PhasePerformanceNoData } from 'components/pages/PhasePerformancePage/components/PhasePerformanceNoData/PhasePerformanceNoData';
import { PhasePerformanceBreakdown } from 'components/widgets/PhasePerformanceBreakdown/PhasePerformanceBreakdown';
import { PhasePerformanceChart } from 'components/widgets/PhasePerformanceChart/PhasePerformanceChart';

export const PhasePerformancePage = () => {
    useFullStoryPageView({ pageName: portfolioConfig.phasePerformance.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={portfolioConfig.phasePerformance.title} />
                    <FiltersWrapper />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <PhasePerformanceChart />
                <PhasePerformanceBreakdown />
                <PhasePerformanceNoData />
            </MainContent>
        </PageContainer>
    );
};
